import type { Locale } from "@/domain/localized";
import { de } from "./locales/de";
import { en, type Strings } from "./locales/en";
import { es } from "./locales/es";
import { fr } from "./locales/fr";
import { hi } from "./locales/hi";
import { ru } from "./locales/ru";
import { sr } from "./locales/sr";
import { tr } from "./locales/tr";

export { en, ru };
export type { Strings };

export const strings: Record<Locale, Strings> = { en, ru, hi, tr, de, fr, es, sr };

/** Replaces `{name}` placeholders. */
export function format(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? ""));
}
